import { render, staticRenderFns } from "./OfferSalesCrossSell.vue?vue&type=template&id=d43abb40&scoped=true"
import script from "./OfferSalesCrossSell.vue?vue&type=script&lang=js"
export * from "./OfferSalesCrossSell.vue?vue&type=script&lang=js"
import style0 from "./OfferSalesCrossSell.vue?vue&type=style&index=0&id=d43abb40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d43abb40",
  null
  
)

export default component.exports